import arrows from './animations/arrows.json';
import coins from './animations/coins.json';
import cryptoPay from './animations/crypto-pay.json';
import derivatives from './animations/derivatives.json';
import earn from './animations/earn.json';
import home from './animations/home.json';
import menu from './animations/menu.json';
import wallet from './animations/wallet.json';

type animationsType =
  | typeof menu
  | typeof home
  | typeof coins
  | typeof arrows
  | typeof wallet
  | typeof earn
  | typeof derivatives
  | typeof cryptoPay;

const animations: Record<string, animationsType> = {
  'menu-icon-home': home,
  'menu-icon-exchange': coins,
  'menu-icon-trade': arrows,
  'menu-icon-wallet': wallet,
  'menu-icon-earn': earn,
  'menu-icon-menu': menu,
  'menu-icon-derivatives': derivatives,
  'menu-icon-crypto-pay': cryptoPay,
};

export default animations;
